import styles from "./IntroSection.module.css";
import logo from "../../../assets/logo.svg";
import { MdMenu } from "react-icons/md";
import { useRef } from "react";
import MenuModal from "../MenuModal/MenuModal";

export default function IntroSection() {
  const handleNavigation = (url) => {
    window.location.href = url;
  };

  const ref = useRef();

  const handleModalOpen = () => {
    ref.current.showModal();
  };

  return (
    <div className={styles.section}>
      <header className={styles.header}>
        <div className={styles.alignLeft}>
          <span className={styles.logoWrapper}>
            <img src={logo} alt="" />
          </span>
          <span className={styles.appName}>StartAppify</span>
        </div>
        <div className={styles.alignRight}>
          <div className={styles.menu} onClick={handleModalOpen}>
            <MdMenu />
          </div>
        </div>
      </header>
      <div className={styles.alignCenter}>
        <div className={styles.textBold}>
          Adding Digital Wings to Small Businesses
        </div>
        <div className={styles.desc}>All-in-one solution for your business</div>
        <button
          className={styles.bgBlueBtn}
          onClick={() =>
            handleNavigation("https://startappify.com/contact-us/")
          }
        >
          Contact us
        </button>
      </div>
      <MenuModal ref={ref} />
    </div>
  );
}
